import React, { useEffect, useState } from 'react';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { PracticalAnalysis } from './pages/PracticalAnalysis';
import { TianGanDiZhi } from './pages/TianGanDiZhi';
import { WuXing } from './pages/WuXing';
import { ShiShen } from './pages/ShiShen';
import { CangGan } from './pages/CangGan';
import { NaYin } from './pages/NaYin';
import { ZiZuo } from './pages/ZiZuo';
import { KongWang } from './pages/KongWang';
import { ShenSha } from './pages/ShenSha';
import { DaYun } from './pages/DaYun';
import { LiuNian } from './pages/LiuNian';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage setCurrentPage={setCurrentPage} data-id="element-0" />;
      case 'practical':
        return <PracticalAnalysis data-id="element-1" />;
      case 'tiangandizhi':
        return <TianGanDiZhi data-id="element-2" />;
      case 'wuxing':
        return <WuXing data-id="element-3" />;
      case 'shishen':
        return <ShiShen data-id="element-4" />;
      case 'canggan':
        return <CangGan data-id="element-5" />;
      case 'nayin':
        return <NaYin data-id="element-6" />;
      case 'zizuo':
        return <ZiZuo data-id="element-7" />;
      case 'kongwang':
        return <KongWang data-id="element-8" />;
      case 'shensha':
        return <ShenSha data-id="element-9" />;
      case 'dayun':
        return <DaYun data-id="element-10" />;
      case 'liunian':
        return <LiuNian data-id="element-11" />;
      default:
        return <HomePage setCurrentPage={setCurrentPage} data-id="element-12" />;
    }
  };
  return <Layout currentPage={currentPage} setCurrentPage={setCurrentPage} data-id="element-13">
      {renderPage()}
    </Layout>;
}